import { Shape } from 'three';

export function createEllipseShape(width: number, height: number): Shape {
  const shape = new Shape();
  shape.absellipse(0, 0, width / 2, height / 2, 0, Math.PI * 2, false, 0);
  return shape;
}

export function createRoundedRectShape(
  width: number,
  height: number,
  radius: number
): Shape {
  const x = -width / 2;
  const y = -height / 2;
  const safeRadius = Math.min(radius, width / 2, height / 2);
  const shape = new Shape();
  shape.moveTo(x + safeRadius, y);
  shape.lineTo(x + width - safeRadius, y);
  shape.quadraticCurveTo(x + width, y, x + width, y + safeRadius);
  shape.lineTo(x + width, y + height - safeRadius);
  shape.quadraticCurveTo(x + width, y + height, x + width - safeRadius, y + height);
  shape.lineTo(x + safeRadius, y + height);
  shape.quadraticCurveTo(x, y + height, x, y + height - safeRadius);
  shape.lineTo(x, y + safeRadius);
  shape.quadraticCurveTo(x, y, x + safeRadius, y);
  return shape;
}

export function getNodeDataString(
  data: unknown,
  key: string,
  fallback = ''
): string {
  if (!data || typeof data !== 'object') return fallback;
  const value = (data as Record<string, unknown>)[key];
  return typeof value === 'string' ? value : fallback;
}
